const NAP = {
  streetAddress: "164 Dixie Lane",
  addressLocality: "Trout",
  addressRegion: "LA",
  postalCode: "71371",
  addressCountry: "US",
};

export const businessSchema = (origin) => ({
  "@context": "https://schema.org",
  "@type": "HVACBusiness",
  "@id": `${origin}/#business`,
  name: "McCann and Sons HVAC Service",
  url: origin,
  telephone: "+1-318-312-2112",
  priceRange: "$$",
  image: `${origin}/logo.png`,
  description:
    "Family-owned 24/7 HVAC service, repair, and full system installation for residential and commercial clients across Trout and Central Louisiana.",
  address: { "@type": "PostalAddress", ...NAP },
  geo: { "@type": "GeoCoordinates", latitude: 31.6296, longitude: -92.1847 },
  openingHoursSpecification: {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    opens: "00:00",
    closes: "23:59",
  },
  areaServed: [
    "Trout, LA", "Jena, LA", "Urania, LA", "Olla, LA", "Tullos, LA",
    "Alexandria, LA", "Pineville, LA", "Ball, LA", "Pollock, LA",
    "Dry Prong, LA", "Georgetown, LA", "Winnfield, LA",
  ].map((name) => ({ "@type": "City", name })),
  sameAs: ["https://blog.jcmandsonshvac.com"],
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const serviceSchema = (origin, { name, description, area }) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: name,
  name,
  description,
  provider: { "@id": `${origin}/#business` },
  areaServed: area
    ? { "@type": "City", name: area }
    : { "@type": "AdministrativeArea", name: "Central Louisiana" },
  hoursAvailable: "Mo-Su 00:00-23:59",
});

export const servicesSchema = (origin) => [
  serviceSchema(origin, {
    name: "Residential HVAC Repair and Installation",
    description:
      "24/7 residential AC repair, furnace and heat pump service, ductless mini-splits, and full system installation for homes across Central Louisiana.",
  }),
  serviceSchema(origin, {
    name: "Commercial Mechanical HVAC Service",
    description:
      "Commercial rooftop package units, split systems, ventilation, preventive maintenance agreements, and 24/7 emergency mechanical HVAC response for businesses in Central Louisiana.",
  }),
  serviceSchema(origin, {
    name: "24/7 Emergency HVAC Repair",
    description:
      "Live-answer emergency heating and cooling repair at any hour, dispatched from Trout, LA with stocked service vehicles.",
  }),
  serviceSchema(origin, {
    name: "HVAC System Replacement and Installation",
    description:
      "Load-calculated, code-compliant installation of high-efficiency air conditioners, heat pumps, furnaces, and commercial package units with manufacturer-registered warranties.",
  }),
];
